@reference "~/styles.css";

@layer components {
	.button {
		@apply normal-case;

		&:global(.ant-btn-default:not(:disabled)) {
			@apply text-grey-800;

			&:active,
			&:hover,
			&:focus {
				@apply border-primary-500 text-primary-500 z-10;
			}
		}

		&:global(.ant-btn-primary) {
			@apply bg-primary-600 border-primary-600;

			&:active,
			&:hover,
			&:focus {
				@apply bg-primary-500 border-primary-500;
			}

			&:disabled {
				@apply bg-grey-200 border-grey-200 text-grey-500;
			}
		}

		&:global(.ant-btn-secondary) {
			@apply bg-white border-primary-600 text-primary-600;

			&:active,
			&:hover,
			&:focus {
				@apply border-primary-500 text-primary-500;

				path {
					@apply stroke-current text-primary-500;
				}
			}

			&:disabled {
				@apply text-graphite-400 bg-grey-200 border-grey-400;
			}
		}

		&:global(.ant-btn-link) {
			@apply text-primary-600 divide-none bg-transparent shadow-none;

			&:active,
			&:hover,
			&:focus {
				@apply divide-none bg-transparent text-primary-500;
			}
			&[ant-click-animating-without-extra-node]:after {
				content: none;
			}
			&:disabled {
				@apply text-graphite-275;
			}
		}

		&:global(.ant-btn-ghost[disabled]) {
			@apply bg-white/15;
		}

		&:global(.ant-btn-tiny) {
			@apply px-[5px] text-11 h-[18px];
		}

		& :global(.anticon) {
			@apply inline-flex;
		}
	}

	/* TYPES */

	.primary,
	.secondary,
	.default {
		@apply uppercase;
	}

	.dark {
		@apply bg-grey-850 border-none text-grey-100 hover:text-grey-100 hover:bg-grey-800 active:text-grey-100 active:bg-grey-800 focus:text-grey-100 focus:bg-grey-800;
	}

	/* LAYOUT */

	.layoutInline {
		@apply inline;
	}

	.layoutBlock {
		@apply block w-full;
	}

	/* MISC */

	.active {
		@apply !border-primary-500 !text-primary-500 !z-10;
	}

	.compact {
		@apply flex items-center px-3 gap-2 text-13 leading-none !normal-case h-[23px];

		svg {
			@apply text-[9px];
		}
	}
}
